const boaUrl = process.env.BRANDS_OPEN_API_URL;
const connectorAppUrl = process.env.CONNECTOR_APP_URL;
const stripePublishKey = process.env.STRIPE_PUBLISH_KEY;
const stripeClientId = process.env.STRIPE_CLIENT_ID;
const stage = process.env.BUILD_ENV;
const appUrl = process.env.BRANDS_OPEN_APP_URL;
const appUrlV1 = process.env.V1_APP_URL;
const shopifyAppName = process.env.SHOPIFY_APP_NAME || 'klickly-local';
const bcAppId = process.env.BC_APP_ID;
const clarityProjectId = process.env.CLARITY_PROJECT_ID;

const isGoogleOauthEnabled = process.env.GOOGLE_ENABLE_OAUTH === 'true';
const isMicrosoftOauthEnabled = process.env.MICROSOFT_ENABLE_OAUTH === 'true';

const isShopifyStorePageEnabled = process.env.SHOPIFY_STORE_PAGE_ENABLED === 'true';
const isFeedbackModalEnabled = process.env.FEEDBACK_MODAL_ENABLED === 'true';

const ga4ServiceAccount = process.env.GA4_SERVICE_ACCOUNT;

const config = {
    boaUrl,
    connectorAppUrl,
    appUrl,
    appUrlV1,
    stripePublishKey,
    stripeClientId,
    stage,
    shopifyAppName,
    isGoogleOauthEnabled,
    isMicrosoftOauthEnabled,
    bcAppId,
    isShopifyStorePageEnabled,
    clarityProjectId,
    isFeedbackModalEnabled,
    ga4ServiceAccount
};

export default config;
